(function () {
    "use strict";

    /**
     * An element that would use this directive must be with position relative and overflow hidden.
     *
     * You can change the effect color by passing the rgb values, here is an example:
     * <a h-animate-bg="0, 0, 0"></a>
     */
    angular
        .module('directives')
        .directive('hAnimateBg', function () {
            return {
                restrict: 'A',
                scope: {},
                link: function (scope, elm, attrs) {
                    elm.on('click', function (e) {
                        var color = attrs.hAnimateBg || '0, 136, 221';
                        var offset = elm.offset();
                        var yOffset = e.pageY - offset.top;
                        var xOffset = e.pageX - offset.left;
                        var animateElm = '<div class="h-animate-bg-elm" style="top:'+yOffset+'px;left:'+xOffset+'px;background: rgba('+color+', 0.2);"></div>';
                        var _animateElm = $(animateElm);

                        elm.append(_animateElm);

                        setTimeout(function () {
                            _animateElm.remove();
                        }, 800);
                    });
                },
            };
        });
})();